// components/ProtectedRoute.tsx
import { Navigate } from "react-router-dom";
import { Cookie } from "../hooks/useStorage";
import { JSX } from "react";
import Cookies from "js-cookie";

const ProtectedRoute = ({ children }: { children: JSX.Element }) => {
  const token = Cookies.get()?.access_token;
  return token ? children : <Navigate to="/" replace />;
};

export default ProtectedRoute;
